//画像クラス
class DataClass {
  constructor() {
    this.imageAsset = {};//一時保存画像データ
    this.settingAsset = [];//一時保存設定値
    this.backRow = 30;//一時保存画像データ

  }
// *****************************
// imagePreLoad:使用する画像をメモリ上に保持する
// @return {void}
// *****************************
  imagePreLoad(func) {
    var self = this;
    loadImage(func);
    function loadImage(endFunc){
      var queue = new createjs.LoadQueue(true);
      // manifestの読込
      queue.loadManifest([
        {id: 'dog_on' ,src: './assets/images/dog_on.png' },
        {id: 'dog_off' ,src: './assets/images/dog_off.png' },
        {id: 'back' ,src: './assets/images/back.jpg' }
      ]);
      // ファイルが1つ読込完了するたびにfileloadイベントが発生
      queue.addEventListener('fileload', handleFileLoad);
      // 全ファイルの読み込みが終わった時completeイベントが発生する
      queue.addEventListener('complete', handleComplete);
      // ファイルが1つ読込完了すると呼ばれる。引数にファイルの読込結果を含むオブジェクトが渡される
      function handleFileLoad(e){
        if(e.item.id === 'back'){
          self.imageAsset[e.item.id] = (e.result);
        }else if(e.item.id === 'dog_on' || e.item.id === 'dog_off'){
          self.imageAsset[e.item.id] = self.imageResize(e.result,100);
        }else{
          self.imageAsset[e.item.id] = e.result;
        }
      }
      // ファイルがすべて読込完了すると呼ばれる
      function handleComplete(){
        //console.log('くしの画像保持完了！');
        if(endFunc) {
    	    self.loadSound(endFunc);
        }
      }
    }
  }
  // sound
  loadSound(func){
    // サウンドを事前に登録
    // var queue = new createjs.LoadQueue(false);
    // queue.installPlugin(createjs.Sound);
    // queue.addEventListener('complete', handler);
    // var manifest = [
    //   {src: '/assets/sounds/se/pyu-n.mp3', id: 'jump'},
    //   {src: '/assets/sounds/bgm/play_game.mp3', id: 'play'}
    // ];
    if (!createjs.Sound.initializeDefaultPlugins()) {return;}
      var audioPath = "/assets/sounds/";
      var sounds = [
        {id:"jump", src:"se/pyu-n.mp3"},
        {id:"play", src:"bgm/play_game.mp3"}
      ];
      createjs.Sound.alternateExtensions = ["mp3"];
      createjs.Sound.on("fileload", handler);
      createjs.Sound.registerSounds(sounds, audioPath);

  //   queue.loadManifest(manifest);
  //   // ファイルが1つ読込完了するたびにfileloadイベントが発生
  //   queue.addEventListener('fileload', handleFileLoad);
  //   function handleFileLoad(e){
  // //     console.log("音の登録")
  //     createjs.Sound.registerSound(e.item.src,e.item.id);
  //   }
    function handler(){
      //console.log('音の読み込み完了！');
      if(func) {
        func();
      }
    }
  }
  adaptImage(image) {
    // 作業場所としてのCanvasを作成
    var canvas = document.createElement("canvas");
    canvas.width = image.width* window.devicePixelRatio;
    canvas.height = $(window).height() * window.devicePixelRatio;
    var workspace = new createjs.Stage(canvas);
    var bitmap = new createjs.Bitmap(image);
    var aspectRatio = canvas.width / canvas.height;
    var imageAspectRatio = image.width / image.height;
     if (imageAspectRatio < aspectRatio) {
         var scale = canvas.width / image.width;
     } else {
        var scale = canvas.height / image.height;
    }
    bitmap.scaleX = bitmap.scaleY = scale;
    bitmap.x = (canvas.width - bitmap.scaleX * image.width);
    bitmap.y = (canvas.height - bitmap.scaleY * image.height);
    workspace.addChild(bitmap);
    workspace.update();
    var adaptedImage = new Image();
    adaptedImage.src = canvas.toDataURL();
    return adaptedImage;
}
  imageResize(image,width){
    // 作業場所としてのCanvasを作成
    var canvas = document.createElement("canvas");
    var scale = (width / image.width);
    canvas.width = (image.width) * scale;
    canvas.height = (image.height) * scale;
    var workspace = new createjs.Stage(canvas);
    var bitmap = new createjs.Bitmap(image);
    bitmap.scaleX = bitmap.scaleY = scale;
    bitmap.x = 0;
    bitmap.y = 0;
    workspace.addChild(bitmap);
    workspace.update();
    var image = new Image();
    image.src = canvas.toDataURL();
    return image;
  }


  // *****************************
  // getOtherImageAsset:画像のシェイプを取得する
  // @return {void}
  // *****************************
  getImageAsset(id){
    return this.imageAsset[id];
  }
}
module.exports = DataClass;



// WEBPACK FOOTER //
// ./app/src/js/modules/data.js